import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack } from "@mui/material";

const DocumentsPeopleForm = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
    return (
        <>
            <div>


                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                    <Stack spacing={2}>
                        <h1>Documents people Form</h1>

                        <TextField name="person_id" label='Person id' required {...register("person_id")} />
                        <TextField name="document" label='Document' {...register("document")} />






                        <Button type='submit' variant="outlined">Submit</Button>

                    </Stack>

                </form>


            </div>
        </>
    )
}

export default DocumentsPeopleForm